export const freeServiceTranslationsEn = {
  servicesManagement: {
    card: {
      free: 'Free',
      usageLimit: 'Up to {{count}} per customer',
      hiddenFromCustomers: 'Hidden from customers',
    },
    fields: {
      priceHelp: 'Use 0 to offer this service for free. A usage limit is available only then.',
      visibleToCustomers: 'Visible to customers',
      visibleToCustomersHelp: 'Turn this off to keep the service available for staff bookings only.',
      usageLimit: 'Usage limit per customer',
      usageLimitHelp: 'How many times each customer can book this free service. Leave empty for no limit.',
    },
    validation: {
      priceRequired: 'Enter a price of zero or more.',
      usageLimitInvalid: 'Usage limit must be a whole number of at least 1.',
      freeServiceConfiguration: 'Check the price, usage limit, and prepayment. A usage limit is only allowed when the price is 0, and a free service cannot ask for a deposit.',
    },
  },
  customer: {
    store: {
      freePrice: 'Free',
    },
    appointments: {
      booking: {
        freeServiceUsageExceeded: 'You have already booked this free service the maximum number of times.',
        serviceNotVisible: 'This service is not available to book online.',
      },
    },
  },
  managementAppointments: {
    book: {
      freeServiceUsageExceeded: 'This customer has already booked this free service the maximum number of times.',
    },
  },
};

export const freeServiceTranslationsPt = {
  servicesManagement: {
    card: {
      free: 'Grátis',
      usageLimit: 'Até {{count}} por cliente',
      hiddenFromCustomers: 'Oculto para clientes',
    },
    fields: {
      priceHelp: 'Use 0 para oferecer este serviço grátis. O limite de utilizações só fica disponível nesse caso.',
      visibleToCustomers: 'Visível para clientes',
      visibleToCustomersHelp: 'Desative para manter o serviço disponível apenas para marcações da equipa.',
      usageLimit: 'Limite de utilizações por cliente',
      usageLimitHelp: 'Quantas vezes cada cliente pode marcar este serviço grátis. Deixe vazio para não limitar.',
    },
    validation: {
      priceRequired: 'Introduza um preço igual ou superior a zero.',
      usageLimitInvalid: 'O limite de utilizações tem de ser um número inteiro de pelo menos 1.',
      freeServiceConfiguration: 'Verifique o preço, o limite de utilizações e o pré-pagamento. O limite só é permitido quando o preço é 0, e um serviço grátis não pode exigir um sinal.',
    },
  },
  customer: {
    store: {
      freePrice: 'Grátis',
    },
    appointments: {
      booking: {
        freeServiceUsageExceeded: 'Já marcou este serviço grátis o número máximo de vezes.',
        serviceNotVisible: 'Este serviço não está disponível para marcação online.',
      },
    },
  },
  managementAppointments: {
    book: {
      freeServiceUsageExceeded: 'Este cliente já marcou este serviço grátis o número máximo de vezes.',
    },
  },
};

export const freeServiceTranslationsEs = {
  servicesManagement: {
    card: {
      free: 'Gratis',
      usageLimit: 'Hasta {{count}} por cliente',
      hiddenFromCustomers: 'Oculto para los clientes',
    },
    fields: {
      priceHelp: 'Usa 0 para ofrecer este servicio gratis. El límite de usos solo está disponible en ese caso.',
      visibleToCustomers: 'Visible para los clientes',
      visibleToCustomersHelp: 'Desactívalo para que el servicio solo se pueda reservar desde el equipo.',
      usageLimit: 'Límite de usos por cliente',
      usageLimitHelp: 'Cuántas veces puede reservar cada cliente este servicio gratis. Déjalo vacío para no limitar.',
    },
    validation: {
      priceRequired: 'Introduce un precio igual o mayor que cero.',
      usageLimitInvalid: 'El límite de usos debe ser un número entero de al menos 1.',
      freeServiceConfiguration: 'Revisa el precio, el límite de usos y el prepago. El límite solo se permite cuando el precio es 0, y un servicio gratis no puede pedir un depósito.',
    },
  },
  customer: {
    store: {
      freePrice: 'Gratis',
    },
    appointments: {
      booking: {
        freeServiceUsageExceeded: 'Ya has reservado este servicio gratis el número máximo de veces.',
        serviceNotVisible: 'Este servicio no está disponible para reservar en línea.',
      },
    },
  },
  managementAppointments: {
    book: {
      freeServiceUsageExceeded: 'Este cliente ya ha reservado este servicio gratis el número máximo de veces.',
    },
  },
};
